import React from 'react';
import { graphql, useFragment } from 'react-relay';
import { useIntl } from '@atlassian/jira-intl';
import type { GroupPickerGroupHeader$key } from '@atlassian/jira-relay/src/__generated__/GroupPickerGroupHeader.graphql';
import { TextGroupHeaderContent } from '../../../../common/text-group-header-content/index.tsx';
import messages from './messages.tsx';

export type Props = {
	groupPickerGroupHeader: GroupPickerGroupHeader$key | null;
};

export const GroupPickerGroupHeader = ({ groupPickerGroupHeader }: Props) => {
	const data = useFragment<GroupPickerGroupHeader$key>(
		graphql`
			fragment GroupPickerGroupHeader on JiraJqlGroupFieldValue {
				group {
					name
				}
			}
		`,
		groupPickerGroupHeader,
	);

	const { formatMessage } = useIntl();

	return (
		<TextGroupHeaderContent
			text={data?.group?.name}
			noValueText={formatMessage(messages.noGroup)}
		/>
	);
};
